//TODO: Convert this into a global modal component which can be invoked by a useModal hook.
//https://refine.dev/docs/core/hooks/utilities/use-modal/#properties this could be a good way to start about it.

import styled from "styled-components";
import { StyledButtonProps } from "./Buttons";
import { IonSpinner } from "@ionic/react";

export const ModalOverlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.5);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 310;
`;

export const Modal = styled.div`
	display: flex;
	overflow-x: hidden;
	flex-direction: column;
	align-items: left;
    text-align:left;
	background: #bbb9b9;
	padding: 2rem;
	width: 85%;
	height: max-content;
	border-radius: 10px;
	z-index: 111;
`;

export const ModalHeader = styled.div`
	text-align: left;
	font-style: normal;
	font-weight: 600;
	font-size: 22px;
    color: #000;
`;

export const ModalSubtitle = styled.div<any>`
    margin: ${props => props.margin || "1.5rem 0 0 0"};
	font-weight: 400;
	font-size: 15px;
	line-height: 18px;
	text-align: left;
    color: #1A1A1A;
`;

export const ModalNote = styled.div`
    margin: 1rem 0 0 0;
	color: #5b5b5b;
	font-size: 13px;
	font-weight: 400;
`;

//Extend this whenever needed. Current options satisfy all the requirements of the current design language.
type ModalButtonGroupAlignment = 'right' | 'center' | 'space-between' | 'space-around'

interface ModalButtonGroupProps {
	alignItems?: ModalButtonGroupAlignment
}

export const ModalButtonGroup = styled.div<ModalButtonGroupProps>`
	margin: 1.5rem 0 0 0;
	display: flex;
	justify-content: ${props => props.alignItems || "center"};
	align-items: center;
	width: 100%;
	gap: 0.5rem;
`;

const PrimaryButton = styled.div<any>`
	padding: 0 0.5rem;
	width:50%;
	max-width: 140px;
	height: 39px;
	background: #000;
	color: #bbb9b9;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 500;
	font-size: 14px;
	&:disabled {
		pointer-events: none;
		opacity: 0.6;
	}
	text-transform: uppercase;
`;

const SecondaryButton = styled.div<any>`
    width:50%;
	max-width: 140px;
	height: 39px;
	border: 1px solid #000;
	color: #000;
	border-radius: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
	font-size: 14px;
	&:disabled {
		pointer-events: none;
		opacity: 0.6;
	}
	text-transform: uppercase;	
`;

export const ModalPrimaryButton = ({ children, onClick, disabled, loading }: StyledButtonProps) => {
	const isDisabled = loading || disabled;
	return (
		<PrimaryButton disabled={isDisabled} onClick={onClick} >
			{loading ? <IonSpinner color={"#000"} name="dots" /> : children}
		</PrimaryButton>
	);
};

export const ModalSecondaryButton = ({ children, onClick, disabled, loading }: StyledButtonProps) => {
	const isDisabled = loading || disabled;
	return (
		<SecondaryButton disabled={isDisabled} onClick={onClick} >
			{loading ? <IonSpinner color={"#000"} name="dots" /> : children}
		</SecondaryButton>
	);
};